const ro = {
    actionAlready: "Nu ești încă înregistrat? Autentifică-te",
    actionExit: "Ieșire",
    actionLogin: "AUTENTIFICARE",
    actionRegister: "ÎNREGISTRARE",
    actionSave: "SALVEAZĂ",
    actionStart: "ÎNCEPE",
    actionContinue: "CONTINUĂ",
    actionReset: "RESETARE EVALUARE",
    actionDoDiagnost: "ARATĂ DIAGNOSTICUL",
    actionYes: "Da",
    actionNo: "Nu",
    actionNext: "URMĂTORUL",
    actionBusinessCase: "ARATĂ BUNELE PRACTICI ALE COMPANIEI",
    actionBusinessCases: "ARATĂ BUNELE PRACTICI ALE COMPANIILOR",
    actionOpenUrl: "DESCHIDE URL",
    actionFilter: "FILTRARE",

    /** HOME */
    msgHomeTitleOne: "Măsurați și creșteți nivelul de maturitate circulară al companiei dumneavoastră de mobilier",
    msgHomeSubTitle: "Instrumentul online FurnCIRCLE evaluează progresul companiei dumneavoastră către maturitatea circulară pe baza strategiilor de design circular implementate",

    msgHomeSection2: "Evaluează și îmbunătățește maturitatea economiei circulare a companiei tale de mobilier",
    msgHomeSection2Text: "<span style='font-weight:bold;'>Instrumentul FurnCIRCLE de evaluare a economiei circulare</span><br/><br/>FurnCIRCLE este un instrument online de autoevaluare care ajută producătorii de mobilier să își evalueze maturitatea în economia circulară și să identifice oportunități de îmbunătățire.<br/><br/><span style='font-weight:bold;'>Ești pregătit să îți evaluezi maturitatea circulară?</span><ul style='padding-left: 20px'><li>Răspunde la întrebări despre strategiile de design circular implementate în compania ta.</li><li>Descoperă nivelul tău de maturitate în economia circulară.</li><li>Identifică strategii și bune practici care să ajute compania ta să treacă la nivelul următor.</li><li>Învață din exemple reale din industrie și continuă să îți îmbunătățești performanța circulară.</li></ul>",
    msgHomeSection21Text: "<span style='font-weight:bold;'>Contribuie la evaluarea europeană a circularității sectorului de mobilier | Proiectul R-evolve</span><br/><br/>FurnCIRCLE este utilizat în prezent în <a href='https://r-evolve.eu/' target='_blank' rel='noopener noreferrer'>proiectul R-evolve</a> pentru a evalua maturitatea economiei circulare a sectorului european de mobilier. <span style='font-weight:bold;'>Peste 400 de companii din întreaga Europă</span> sunt invitate să participe și să ajute la cartografierea nivelului actual de circularitate din industrie.<br/><br/>Participă la evaluare, evaluează-ți compania și contribuie la modelarea viitorului sectorului.<br/><br/>Toate datele sunt tratate confidențial și utilizate doar în formă agregată pentru benchmarking și cercetare. <span style='font-weight:bold;'>Participanții vor primi acces la rezultate agregate de benchmarking</span>, ceea ce le permite să își compare performanța cu mediile sectoriale pe baza datelor anonimizate și agregate ale companiilor participante din sectorul european de mobilier.<br/><br/>Evaluarea durează aproximativ 30-45 de minute.",
    msgHomeSection3: "Parteneri",
    msgHomeSection2Btn: "Începeți evaluarea",
    msgHomeSection3Btn: "CONTACT",

    /** HEADER */
    msgHeader1: "Strategii de design circular și bune practici",
    msgHeader4: "Autentificare",

    /** DRAWER */
    msgCompany: "COMPANIE",
    msgDrawer1: "1. Răspundeți",
    msgDrawer2: "2. Evaluați",
    msgDrawer3: "3. Îmbunătățiți",
    msgDrawer4: "Colecția de strategii",
    msgDrawer6: "Setări",
    msgDrawer7: "Ieșire",

    /** LOGIN */
    msgWelcome: "Bine ați venit",
    msgWelcomeSubtitle: "Vă rugăm să vă autentificați pentru a continua",

    /** REGISTER */
    msgGetStarted: "Începeți",
    msgGetStartedSubtitle: "Acest instrument de autoevaluare este gratuit și confidențial",

    msgFirstname: "Prenume",
    msgLastname: "Nume de familie",
    msgEmail: "Email",
    msgPassword: "Parolă",
    msgConfirmPassword: "Confirmați parola",
    msgCompanyUser: "Companie sau nume de utilizator",

    msgLegalRegister: "Am citit și sunt de acord cu <a href='https://ambitcluster.org/en/privacy-policy'>Politica de confidențialitate.</a>",
    errorLegalRegister: "Trebuie să citiți și să acceptați Politica de confidențialitate înainte de a continua",
    msgLegalRegisterText: "Notă: Datele personale sunt colectate de AMBIT prin Instrumentul FurnCIRCLE exclusiv în scopuri tehnice și operaționale. Răspunsurile la sondaj vor fi analizate în cadrul proiectului R-evolve. Nicio date personale sau informații care identifică compania nu vor fi partajate cu partenerii consorțiului R-evolve. Toate răspunsurile vor fi analizate pe o bază strict anonimă. În scopuri statistice, datele pot fi agregate pe țară sau sector de activitate. În nicio circumstanță rezultatele generate de instrument nu vor fi legate sau utilizate pentru identificarea oricărei companii individuale.",

    msgNotRegister: "Nu sunteți încă înregistrat? <b>Creați un cont aici</b>",
    msgAlreadyRegister: "Sunteți deja înregistrat? <b>Autentificați-vă aici</b>",

    /** HOME TOOL */
    msgClickImage: "Faceți clic pentru a extinde sistemul modelului liniar versus circular.",

    msgArea: "ZONĂ",
    msgProgress: "ÎNTREBĂRI RĂSPUNSE",

    msgAssessmentAreas: "Strategii de design circular și ciclul de viață al produsului",
    msgAssessmentDesc: "Strategiile de proiectare circulară sunt aplicate în principal în faza de proiectare și dezvoltare a produselor. Totuși, impactul lor (pozitiv) are loc în una sau mai multe faze ulterioare ale ciclului de viață al produsului, susținut de serviciile post-vânzare. Prin urmare, o modalitate de clasificare a strategiilor de proiectare circulară este în funcție de etapa ciclului de viață asupra căreia au impact: proiectare, resurse materiale, producție, distribuție, faza de utilizare și sfârșitul vieții produsului.<br/><br/>Pentru implementarea strategiilor de circularitate, abordarea generală a unei companii către viitoarea Economie Circulară este esențială, la fel ca 'aspectele produsului' prevăzute la Art. 5(1) din Regulamentul european privind Ecodesignul pentru Produse Sustenabile (ESPR) și Pașaportul Digital al Produsului (DPP) introdus prin ESPR.<br/><br/>ESPR este unul dintre pilonii strategiei UE pentru a permite o Economie Circulară (CE) eficientă din punctul de vedere al resurselor, cu toxicitate redusă și favorabilă climei. Acesta stabilește un cadru de condiții obligatorii de intrare pe piață pentru produse, impunând ținte ambițioase de performanță de mediu și eficiență a resurselor pentru a rămâne în limitele planetare. Conform 'aspectelor produsului' din Art. 5(1), produsele trebuie proiectate pentru utilizare îndelungată, reparație ușoară, reutilizare și recondiționare, precum și reciclare sigură (cunoscute și ca strategiile R). De asemenea, trebuie să fie lipsite de substanțe problematice și adecvate pentru recuperarea materialelor de înaltă calitate.<br/><br/>DPP, astfel cum este introdus prin ESPR, este destinat să ofere infrastructura armonizată corespunzătoare pentru datele despre produse, capabilă să stimuleze transparența, trasabilitatea și inovația sustenabilă în afaceri.<br/><br/>Pentru detalii, consultați fișa R-evolve | <a href='https://r-evolve.eu/' target='_blank' rel='noopener noreferrer'>https://r-evolve.eu/</a><br/><br/><span style='font-weight:bold;'>Vă rugăm să răspundeți la toate întrebările pentru fiecare bloc sau fază a ciclului de viață, să determinați nivelul de maturitate circulară și să planificați îmbunătățirea și tranziția către o Economie Circulară mai avansată.</span>",

    msgAssessment: "Evaluare FurnCIRCLE",
    msgNotApply: "Bifează toate răspunsurile care se aplică performanței circulare actuale a companiei tale. Răspunsurile sunt salvate automat.",
    msgMarkImportant: "Marcați ca important",
    msgComment: "Comentariu",
    msgCommentHolder: "Puteți scrie aici orice informație legată sau comentarii proprii.",

    /** ANSWER */
    msgPerformance: "Raport de evaluare",
    msgPerformanceSubtitle: "Verificați indicele de maturitate circulară al companiei dumneavoastră și fiecare fază a ciclului de viață al produselor dumneavoastră.",
    msgCompanyLevel: "Indicele de maturitate circulară al companiei dumneavoastră (0%-100%)",
    msgBlockArea: "FAZĂ A CICLULUI DE VIAȚĂ",
    msgBlockValues: "VALORI",

    /** ASSESS */
    msgImprovement: "Raport de îmbunătățire",
    msgImprovementMainSubtitle: "Învățați ce puteți face pentru a îmbunătăți continuu circularitatea companiei dumneavoastră. Cunoașteți strategiile de design și bunele practici ale companiilor pentru a duce compania dumneavoastră la următorul nivel.</br></br>Fazele ciclului de viață și strategiile de design circular cu etichetă/rotundă „roșie” au un nivel de performanță egal sau mai mic de 25% din valoarea lor maximă și pot fi considerate o prioritate de top pentru îmbunătățirea circularității companiei. Fazele sau strategiile cu etichetă/rotundă „portocalie” au un nivel de performanță mai mare de 25% și mai mic sau egal cu 75%, deci este important să abordați și îmbunătățirea acestora. Fazele sau strategiile cu etichetă/rotundă „verde” au un nivel de performanță mai mare de 75% și, prin urmare, sunt mai puțin o prioritate pentru îmbunătățire.",
    msgImprovementSubtitle: "Învățați ce puteți face pentru a îmbunătăți continuu circularitatea companiei dumneavoastră. Cunoașteți strategiile de design și bunele practici ale companiilor pentru a duce compania dumneavoastră la următorul nivel.",
    msgLifecyclePhases: "Fazele ciclului de viață",
    msgLifecycleIndex: "Indicele de circularitate al fazei",
    msgActionsToImplement: "Acțiuni de implementat:",
    msgBaselineScore: "Scorul meu de referință",
    msgBusinessCaseEmpty: "Felicitări! Ați implementat deja principalele strategii incluse în această categorie",

    msgCat1: "ECONOMIC ȘI ORGANIZAȚIONAL",
    msgCat2: "SOCIAL",
    msgCat3: "ENVIRONMENTAL",

    /** STRATEGIES COLLECTION */
    msgStrategiesSubtitle: "Răsfoiți și explorați întreaga colecție de strategii de design circular și bune practici ale companiilor din proiectul FurnCIRCLE.",
    msgLifecyclePhase: "Faza ciclului de viață",
    msgDifficulty: "Dificultatea implementării",
    msgBusinessDynamics: "Generare sau livrare de valoare",
    msgBusinessFactors: "Propunere de valoare / Costuri / Beneficii",

    /** SETTINGS */
    msgUserInfo: "Informații utilizator",
    msgUserCredentials: "Date de autentificare utilizator",

    /** MODAL */
    msgAreSure: "Sunteți sigur?",

    msgSuccess: "Actualizare date cu succes",
    msgDeleteSuccess: "Ștergere date cu succes",

    /** ALT TEXT */
    msgSaveCommentAlt: "Salvează “Comentariul”. Nu este necesar să salvezi răspunsurile la întrebări; acestea sunt salvate automat.",
    msgDifficultyAlt: "Această etichetă indică dificultatea implementării strategiei de design circular.",
    msgBusinessBlockAlt: "Această etichetă indică care bloc de afaceri din modelul CANVAS (Generarea Valorii sau Livrarea Valorii) este afectat de implementarea strategiei de design circular.",
    msgImpactBlockAlt: "Această etichetă indică care bloc de impact din modelul CANVAS (Costuri, Beneficii sau Propunerea de Valoare) este afectat de implementarea strategiei de design circular.",

    /** ERROR */
    errorOblData: "Completați toate câmpurile obligatorii",
    errorEmailFormat: "Eroare în formatul emailului",
    errorUserIncorrect: "Email/parolă incorectă",
    errorSend: "Eroare de comunicare, vă rugăm să așteptați și să încercați din nou mai târziu",
    errorLength: "Numărul de caractere a fost depășit",
    errorPassSame: "Parolele nu sunt identice",

    /** RECOVERY PASS */
    msgRecoveryPassword: "Recuperare parolă",
    msgRecoveryPasswordSubtitle: "Vă rugăm să introduceți adresa de email pentru a primi un cod de resetare a parolei.",
    msgCode: "Cod",
    msgNewPassword: "Parolă nouă",
    actionRequestCode: "SOLICITĂ COD",
    actionUpdate: "ACTUALIZEAZĂ",
    actionBack: "ÎNAPOI",
    msgForgetPassword: "Ai uitat parola?",
    errorRecovery: "Eroare la recuperarea parolei, vă rugăm să verificați codul furnizat",

    /** FOOTER */
    msgFooterContact: "CONTACT",

    msgFooterGr: "Finanțat de Uniunea Europeană. Opiniile exprimate sunt însă ale autorului (autorilor) și nu reflectă neapărat punctele de vedere ale Uniunii Europene. Nici Uniunea Europeană, nici autoritatea de acordare nu pot fi făcute responsabile pentru acestea. Referință apel și acord de grant: SOCPL-2022-SOC-DIALOG-01 (Proiect 101102389)",
    msgCopyright: "Copyright&copy;2025 AMBIT. Toate drepturile rezervate",

    msgFooterLegal: "Notificare legală",
    msgFooterPrivacy: "Confidențialitate",
    msgFooterCookies: "Politica de cookies",

    /** PROGRESS VALUES */
    msgProgress0: "Strategii de design circular",

    /** COMPANY SIZES */
    msgCompanySize: "Dimensiunea companiei",
    msgCompanySize1: "Mai puțin de 10 angajați",
    msgCompanySize2: "10-30 angajați",
    msgCompanySize3: "30-50 angajați",
    msgCompanySize4: "Mai mult de 50 angajați",

    /** PRODUCT TYPES */
    msgProductType: "Tipul de produse pe care le fabricați",
    msgProductType1: "Mobilier pentru dormitor și paturi",
    msgProductType2: "Dormitoare pentru copii / tineret",
    msgProductType3: "Sisteme de dormit: saltele și baze",
    msgProductType4: "Mobilier pentru zona de zi",
    msgProductType5: "Scaune",
    msgProductType6: "Bucătării",
    msgProductType7: "Mobilier tapițat",
    msgProductType8: "Mobilier de exterior",
    msgProductType9: "Mobilier flat-pack / DIY",
    msgProductType10: "Mobilier pentru sănătate și îngrijire (spitale, cămine de bătrâni etc.)",
    msgProductType11: "Mobilier pentru spații publice (aeroporturi, biserici, teatre și cinematografe), excluzând șezuturile",
    msgProductType12: "Mobilier rezidențial la comandă",
    msgProductType13: "Accesorii - Elemente complementare",
    msgProductType14: "Accesorii - Obiecte decorative",
    msgProductType15: "Accesorii - Textile",
    msgProductType16: "Amenajări comerciale (retail / contract interiors)",
    msgProductType17: "Componente semifinite pentru mobilier",
    msgProductType18: "Alte tipuri de mobilier",
    msgProductType19: "Mobilier de baie (inclusiv blaturi)",
    msgProductType20: "Mobilier de birou",
    msgProductType21: "Partiții / pereți de birou",
    msgProductType22: "Scaune de birou",
    msgProductType23: "Scaune publice / scaune pentru spații colective",
    msgProductType24: "Panouri acustice / mobilier acustic",
    msgProductType25: "Componente de mobilier de birou",
    msgProductType26: "Alt mobilier / echipamente de birou",
    msgProductType27: "Mobilier educațional",

    /* COUNTRIES */
    msgCountry: "Țară",
    msgAfghanistan: "Afganistan",
    msgAlbania: "Albania",
    msgAlgeria: "Algeria",
    msgAmericanSamoa: "Samoa Americană",
    msgAndorra: "Andorra",
    msgAngola: "Angola",
    msgAnguilla: "Anguilla",
    msgAntarctica: "Antarctica",
    msgAntiguaandBarbuda: "Antigua și Barbuda",
    msgArgentina: "Argentina",
    msgArmenia: "Armenia",
    msgAruba: "Aruba",
    msgAustralia: "Australia",
    msgAustria: "Austria",
    msgAzerbaijan: "Azerbaidjan",
    msgBahamas: "Bahamas",
    msgBahrain: "Bahrain",
    msgBangladesh: "Bangladesh",
    msgBarbados: "Barbados",
    msgBelarus: "Belarus",
    msgBelgium: "Belgia",
    msgBelize: "Belize",
    msgBenin: "Benin",
    msgBermuda: "Bermuda",
    msgBhutan: "Bhutan",
    msgBolivia: "Bolivia",
    msgBosniaHerzegovina: "Bosnia și Herțegovina",
    msgBotswana: "Botswana",
    msgBouvetIsland: "Insula Bouvet",
    msgBrazil: "Brazilia",
    msgBritishIndian: "Teritoriul Oceanului Indian Britanic",
    msgBrunei: "Brunei",
    msgBulgaria: "Bulgaria",
    msgBurkinaFaso: "Burkina Faso",
    msgBurundi: "Burundi",
    msgCambodia: "Cambodgia",
    msgCameroon: "Camerun",
    msgCanada: "Canada",
    msgCapeVerde: "Capul Verde",
    msgCaymanIslands: "Insulele Cayman",
    msgCentralAfrican: "Republica Centrafricană",
    msgChad: "Ciad",
    msgChile: "Chile",
    msgChina: "China",
    msgChristmasIsland: "Insula Crăciunului",
    msgCocosIslands: "Insulele Cocos (Keeling)",
    msgColombia: "Columbia",
    msgComoros: "Comore",
    msgCongo: "Congo",
    msgRepublicCongo: "Republica Democrată Congo",
    msgCookIslands: "Insulele Cook",
    msgCostaRica: "Costa Rica",
    msgIvoryCoast: "Coasta de Fildeș",
    msgCroatia: "Croația",
    msgCuba: "Cuba",
    msgCyprus: "Cipru",
    msgCzechRepublic: "Republica Cehă",
    msgDenmark: "Danemarca",
    msgDjibouti: "Djibouti",
    msgDominica: "Dominica",
    msgDominicanRepublic: "Republica Dominicană",
    msgEastTimor: "Timorul de Est",
    msgEcuador: "Ecuador",
    msgEgypt: "Egipt",
    msgEngland: "Anglia",
    msgElSalvador: "El Salvador",
    msgEquatorialGuinea: "Guineea Echatorială",
    msgEritrea: "Eritreea",
    msgEstonia: "Estonia",
    msgEthiopia: "Etiopia",
    msgFalklandIslands: "Insulele Falkland",
    msgFaroeIslands: "Insulele Feroe",
    msgFijiIslands: "Insulele Fiji",
    msgFinland: "Finlanda",
    msgFrance: "Franța",
    msgFrenchGuiana: "Guyana Franceză",
    msgFrenchPolynesia: "Polinezia Franceză",
    msgFrenchSouthern: "Teritoriile Franceze de Sud",
    msgGabon: "Gabon",
    msgGambia: "Gambia",
    msgGeorgia: "Georgia",
    msgGermany: "Germania",
    msgGhana: "Ghana",
    msgGibraltar: "Gibraltar",
    msgGreece: "Grecia",
    msgGreenland: "Groenlanda",
    msgGrenada: "Grenada",
    msgGuadeloupe: "Guadelupa",
    msgGuam: "Guam",
    msgGuatemala: "Guatemala",
    msgGuernsey: "Guernsey",
    msgGuinea: "Guineea",
    msgGuineaBissau: "Guineea-Bissau",
    msgGuyana: "Guyana",
    msgHaiti: "Haiti",
    msgHeardMcDonald: "Insula Heard și Insulele McDonald",
    msgHolySee: "Sfântul Scaun (Statul Vatican)",
    msgHonduras: "Honduras",
    msgHongKong: "Hong Kong",
    msgHungary: "Ungaria",
    msgIceland: "Islanda",
    msgIndia: "India",
    msgIndonesia: "Indonezia",
    msgIran: "Iran",
    msgIraq: "Irak",
    msgIreland: "Irlanda",
    msgIsrael: "Israel",
    msgIsleMan: "Insula Man",
    msgItaly: "Italia",
    msgJamaica: "Jamaica",
    msgJapan: "Japonia",
    msgJersey: "Jersey",
    msgJordan: "Iordania",
    msgKazakhstan: "Kazahstan",
    msgKenya: "Kenya",
    msgKiribati: "Kiribati",
    msgKuwait: "Kuweit",
    msgKyrgyzstan: "Kârgâzstan",
    msgLaos: "Laos",
    msgLatvia: "Letonia",
    msgLebanon: "Liban",
    msgLesotho: "Lesotho",
    msgLiberia: "Liberia",
    msgLibyanJamahiriya: "Jamahiriya Arabă Libiană",
    msgLiechtenstein: "Liechtenstein",
    msgLithuania: "Lituania",
    msgLuxembourg: "Luxemburg",
    msgMacao: "Macao",
    msgNorthMacedonia: "Macedonia de Nord",
    msgMadagascar: "Madagascar",
    msgMalawi: "Malawi",
    msgMalaysia: "Malaysia",
    msgMaldives: "Maldivele",
    msgMali: "Mali",
    msgMalta: "Malta",
    msgMarshallIslands: "Insulele Marshall",
    msgMartinique: "Martinica",
    msgMauritania: "Mauritania",
    msgMauritius: "Mauritius",
    msgMayotte: "Mayotte",
    msgMexico: "Mexic",
    msgMicronesia: "Micronezia, Statele Federate din",
    msgMoldova: "Moldova",
    msgMonaco: "Monaco",
    msgMongolia: "Mongolia",
    msgMontserrat: "Montserrat",
    msgMontenegro: "Muntenegru",
    msgMorocco: "Maroc",
    msgMozambique: "Mozambic",
    msgMyanmar: "Myanmar",
    msgNamibia: "Namibia",
    msgNauru: "Nauru",
    msgNepal: "Nepal",
    msgNetherlands: "Olanda",
    msgNetherlandsAntilles: "Antilele Olandeze",
    msgNewCaledonia: "Noua Caledonie",
    msgNewZealand: "Noua Zeelandă",
    msgNicaragua: "Nicaragua",
    msgNiger: "Niger",
    msgNigeria: "Nigeria",
    msgNiue: "Niue",
    msgNorfolkIsland: "Insula Norfolk",
    msgNorthKorea: "Coreea de Nord",
    msgNorthernIreland: "Irlanda de Nord",
    msgNorthernMariana: "Insulele Mariane de Nord",
    msgNorway: "Norvegia",
    msgOman: "Oman",
    msgPakistan: "Pakistan",
    msgPalau: "Palau",
    msgPalestine: "Palestina",
    msgPanama: "Panama",
    msgPapua: "Papua Noua Guinee",
    msgParaguay: "Paraguay",
    msgPeru: "Peru",
    msgPhilippines: "Filipine",
    msgPitcairn: "Pitcairn",
    msgPoland: "Polonia",
    msgPortugal: "Portugalia",
    msgPuertoRico: "Puerto Rico",
    msgQatar: "Qatar",
    msgReunion: "Reuniune",
    msgRomania: "România",
    msgRussianFederation: "Federația Rusă",
    msgRwanda: "Rwanda",
    msgSaintHelena: "Sfânta Elena",
    msgSaintKitts: "Saint Kitts și Nevis",
    msgSaintLucia: "Sfânta Lucia",
    msgSaintPierre: "Saint Pierre și Miquelon",
    msgSaintVincent: "Saint Vincent și Grenadinele",
    msgSamoa: "Samoa",
    msgSanMarino: "San Marino",
    msgSaoTome: "Sao Tome și Principe",
    msgSaudiArabia: "Arabia Saudită",
    msgScotland: "Scoția",
    msgSenegal: "Senegal",
    msgSerbia: "Serbia",
    msgSeychelles: "Seychelles",
    msgSierraLeone: "Sierra Leone",
    msgSingapore: "Singapore",
    msgSlovakia: "Slovacia",
    msgSlovenia: "Slovenia",
    msgSolomonIslands: "Insulele Solomon",
    msgSomalia: "Somalia",
    msgSouthAfrica: "Africa de Sud",
    msgSouthSandwich: "Georgia de Sud și Insulele Sandwich de Sud",
    msgSouthKorea: "Coreea de Sud",
    msgSouthSudan: "Sudanul de Sud",
    msgSpain: "Spania",
    msgSriLanka: "Sri Lanka",
    msgSudan: "Sudan",
    msgSuriname: "Surinam",
    msgSvalbardJan: "Svalbard și Jan Mayen",
    msgSwaziland: "Swaziland",
    msgSweden: "Suedia",
    msgSwitzerland: "Elveția",
    msgSyria: "Siria",
    msgTajikistan: "Tadjikistan",
    msgTanzania: "Tanzania",
    msgThailand: "Thailanda",
    msgTimorLeste: "Timorul de Est",
    msgTogo: "Togo",
    msgTokelau: "Tokelau",
    msgTonga: "Tonga",
    msgTrinidadTobago: "Trinidad și Tobago",
    msgTunisia: "Tunisia",
    msgTurkey: "Turcia",
    msgTurkmenistan: "Turkmenistan",
    msgTurksCaicos: "Insulele Turks și Caicos",
    msgTuvalu: "Tuvalu",
    msgUganda: "Uganda",
    msgUkraine: "Ucraina",
    msgUnitedArabEmirates: "Emiratele Arabe Unite",
    msgUnitedKingdom: "Regatul Unit",
    msgUnitedStates: "Statele Unite",
    msgUnitedStatesMinor: "Insulele din Oceanul Pacific ale Statelor Unite",
    msgUruguay: "Uruguay",
    msgUzbekistan: "Uzbekistan",
    msgVanuatu: "Vanuatu",
    msgVenezuela: "Venezuela",
    msgVietnam: "Vietnam",
    msgVirginIslandsBritish: "Insulele Virgine Britanice",
    msgVirginIslandsUS: "Insulele Virgine ale SUA",
    msgWales: "Țara Galilor",
    msgWallisFutuna: "Wallis și Futuna",
    msgWesternSahara: "Sahara de Vest",
    msgYemen: "Yemen",
    msgZambia: "Zambia",
    msgZimbabwe: "Zimbabwe",

}

export default ro;